import { useTranslations } from '@vocab/react';
import { Text, TextLinkButton } from 'braid-design-system';

import translations from './.vocab';

interface Props {
  lastInteractionDuration: string;
  onClick: () => void;
}

export const LastInteraction = ({
  lastInteractionDuration,
  onClick,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Text size="small">
      <TextLinkButton
        onClick={(event) => {
          // This component renders inside a parent Link (<a>) in ProfileCard.
          // - preventDefault: cancel the anchor navigation
          // - stopPropagation: avoid triggering the parent Link's onClick
          // Outcome: only the LastInteraction onClick runs when this is clicked.
          event.preventDefault();
          event.stopPropagation();
          onClick();
        }}
      >
        {t('LAST_INTERACTION', { lastInteractionDuration })}
      </TextLinkButton>
    </Text>
  );
};
